@if (action$ | async; as action) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: action }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: action }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <elder-single-pane-wrapper class="flex">
      <elder-pane-header>
        <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
        <elder-pane-actions>
          <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
              <mat-icon>delete</mat-icon>
              <span>{{ 'actions.delete' | translate }}</span>
            </button>
          </mat-menu>
        </elder-pane-actions>
      </elder-pane-header>
      <elder-pane-content>
        <form #mainFrm="ngForm" class="flex layout-row gap-xl">
          <div class="flex layout-col">
            <div class="layout-row">
              <div class="flex layout-col">
                <!-- Identifications -->
                <elder-pane-subtitle>{{
                  'context.identification' | translate
                }}</elder-pane-subtitle>
                <div class="layout-col gap-md">
                  @if (creationMode) {
                    <mat-form-field class="flex">
                      <mat-label>{{ 'context.id' | translate }}</mat-label>
                      <input
                        matInput
                        name="id"
                        #idModel="ngModel"
                        required
                        placeholder="{{ 'context.id' | translate }}"
                        pattern="{{ idValidatorPattern }}"
                        [(ngModel)]="action.id"
                      />
                      @if (idModel?.errors?.['required']) {
                        <mat-error>{{ 'validations.required' | translate }}</mat-error>
                      }
                    </mat-form-field>
                  }
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.name' | translate }}</mat-label>
                    <input
                      matInput
                      name="name"
                      required
                      placeholder="{{ 'context.name' | translate }}"
                      [(ngModel)]="action.name"
                    />
                  </mat-form-field>
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.description' | translate }}</mat-label>
                    <input
                      matInput
                      name="description"
                      placeholder="{{ 'context.description' | translate }}"
                      [(ngModel)]="action.description"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </form>
      </elder-pane-content>
    </elder-single-pane-wrapper>
  </div>
}

<ng-template #header let-action>
  @if (creationMode) {
    <span>
      {{ 'process.actions.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="'process.actions.action' | translate" [subheader]="'ID: ' + action.id">
    </elder-header>
  }
</ng-template>
